<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Integrated Supply Chain for Diagnostic Customers</div>
				<div class="txt">Diagnostic Tests Available When You Need Them.</div>
			</div>
			<!--块1-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/图像-38@2x.webp"  />
			</div>
			<!--banner-->
			<!--块2-->
			<div class="block_2">
				<div class="txt"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					CorDx is one of the only manufacturers in the world that owns its own IVD manufacturing supply chain. It empowers us to manufacture a comprehensive line of point-of-care lateral flow products that’s recognized around the world.
				</div>
				<div class="txt"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
				>
					From raw materials, labels, and antibodies to plastic cassettes, our internal, fully integrated production plant ensures the world always has access to accurate, affordable, easy-to-use diagnostics products with competitive pricing. This means that you and your end users will never have to worry about backorder situations. IVD products that you order from CorDx will be available to those who need them, when they need them. 
				</div>
				<div class="txt"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>	
					CorDx provides complete supply-chain support for our diagnostics products within a fully ISO Certified environment and a comprehensive QMS System. The efficiency this integration brings to our manufacturing process is unparalleled in the industry–we are our own supplier for almost all of the components in a test! Lateral flow products you order from CorDx will always be available.
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="left">
					<div class="tit">Company Highlights</div>
					<div class="left_main">
						<div class="left_main_el">
							<div class="tit">1,000+</div>
							<div class="txt">Global Business Partners</div>
						</div>
						<div class="left_main_el">
							<div class="tit">3 Million+</div>
							<div class="txt">Sq. Ft. Footprint</div>
						</div>
						<div class="left_main_el">
							<div class="tit">1 Billion+</div>
							<div class="txt">Users of CorDx-manufactured Products Worldwide</div>
						</div>
					</div>
				</div>
				<div class="right">
					<img src="../../assets/img/蒙版组 2@2x.webp" />
				</div>
			</div>
			<!--块3-->
			<!--块6-->
			<div class="block_6"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="left">
					Supply Chain Benefits
				</div>
				<div class="right">
					<div class="right_el">
						<div class="right_left">
							<img src="../../assets/img/路径 431@2x.png" />
						</div>
						<div class="right_right">
							<div class="tit">Quality Control</div>
							<div class="txt">Each stage of CorDx's supply chain operation is optimized to maintain the quality standards we're known for.</div>
						</div>
					</div>
					<div class="right_el">
						<div class="right_left">
							<img src="../../assets/img/组 693@2x.png" />
						</div>
						<div class="right_right">
							<div class="tit">Accessibility</div>
							<div class="txt">
								Our vertically integrated supply chain provides diagnostics customers with the peace of mind that comes with assured product delivery, anywhere in the world.
							</div>
						</div>
					</div>
					<div class="right_el">
						<div class="right_left">
							<img src="../../assets/img/组 707@2x.png" />
						</div>
						<div class="right_right">
							<div class="tit">Cost Savings</div>
							<div class="txt">
								CorDx's integrated supply chain leads to cost savings for our customers and enables us to focus on your requirements instead of material procurement.
							</div>
						</div>
					</div>
					<div class="right_el">
						<div class="right_left">
							<img src="../../assets/img/组 708@2x.png" />
						</div>
						<div class="right_right">
							<div class="tit">Flexibility</div>
							<div class="txt">
								Our supply chain is agile and scalable, enabling us to flexibly respond to your changing business requirements.
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块6-->
			<!--块7-->
			<div class="block_7"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="left">
					<img src="../../assets/img/图像 39@2x.webp" />
					<div class="tit">UNITED STATES</div>
					<div class="txt">
						CorDx has a bicoastal presence in the US for product development, testing, manufacturing, and assembly services.
					</div>
					<div class="txt" style="font-weight: bold;">● San Diego, Calif:</div>
					<div class="txt" style="text-indent: 18px;">
						Late-phase production for IVD developers, including the cutting of lateral flow assay cards/sheets, test cassette assembly, test cassette pouching, and kitting.
					</div>
					<div class="txt" style="font-weight: bold;">● Atlanta, Ga.:</div>
					<div class="txt" style="text-indent: 18px;">
						Injection molding for test cassettes, lateral flow sheet development, and more.
					</div>
					<div class="tit">SINGAPORE</div>
					<div class="txt">
						CorDx’s Singapore facility functions as its headquarters in the Asia-Pacific (APAC) region. This location expands the global distribution of CorDx’s diagnostic tests in the APAC region. The business development center is now operational, while the R&D facility is expected to be completed in one to two years.
					</div>
				</div>
				<div class="right">
					<div class="title">Our Global Network</div>
					<div class="text">
						CorDx’s global footprint enables an integrated supply chain for end-to-end IVD development and manufacturing. We maintain a global network of distribution relationships with some of the world’s leading suppliers to ensure you get your products when promised.
					</div>
					<div class="tit">CHINA</div>
					<div class="txt">
						CorDx’s full-scale manufacturing facility and R&D team in China supports the production of millions of rapid testing products with the flexibility to scale up and down depending on your business requirements and market demand.
					</div>
				</div>
			</div>
			<!--块7-->
			<!--块4-->
			<div class="block_4">
				<div class="left">
					<div class="block_4_el" style="background-color: #FEFCFC;"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Ownership​</div>
						<div class="txt">CorDx’s resources and tooling capabilities include ownership of its own raw material pipeline and close relationships with producers of materials not owned by CorDx.</div>
						<div class="img_box" style="padding-top: 20px;">
							<img src="../../assets/img/蒙版组 1@2x_副本.webp" />
						</div>
					</div>
					<div class="block_4_el" style="background-color: #FEFBF3;"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Supported IVD Technologies & Techniques​</div>
						<ul class="list">
							<li>● Lateral Flow Immunoassays</li>
							<li>● ELISA Immunoassays</li>
							<li>● Visible, fluorescent, and chemiluminescent detection systems</li>
							<li>● Real-time PCR</li>
							<li>● Dry clinical chemistry</li>
							<li>● Microfluidics</li>
							<li>● Recombinant proteins and antibodies</li>
						</ul>
						<div class="img_box" style="padding-top: 20px;">
							<img src="../../assets/img/蒙版组 1@2x (2)_副本.webp" />
						</div>
					</div>
				</div>
				<div class="right">
					<div class="block_4_el" style="background-color: #FBFEFC;margin-top: 0;"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box">
							<img src="../../assets/img/img@2x.webp" />
						</div>
						<div class="tit" style="padding-top: 20px;">Contract Manufacturing</div>
						<div class="txt">We provide contract manufacturing solutions for startups to large enterprises alike. CorDx performs contract manufacturing for products we developed as well as from technology transfers. Trust CorDx for efficient manufacturing, quality products, and proficiency in regulatory affairs.</div>
						<div class="btn_box_more btn_box" @click="goContractManufacturing">
							Learn More<img src="../../assets/img/组 32@2x.png" />
						</div>
					</div>
					<div class="block_4_el" style="background-color: #FBFEFC;"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="img_box">
							<img src="../../assets/img/image03@2x.webp" />
						</div>
						<div class="tit" style="padding-top: 20px;">IVD Applications</div>
						<div class="txt">CorDx provides raw IVD materials and consumables for:</div>
						<ul class="list">
							<li>● Respiratory Diseases</li>
							<li>● Infectious Diseases</li>
							<li>● Sexually Transmitted Diseases</li>
							<li>● Fertility Monitoring</li>
							<li>● Drugs of Abuse</li>
							<li>● Cardiac Markers</li>
							<li>● Tumor Markers</li>
							<li>● Health Tests</li>
							<li>● Blood Glucose</li>
							<li>● And more</li>
						</ul>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/组 696@2x.webp" class="bg" />
				<div class="msg_box">
					<div class="tit">Partner With Us</div>
					<div class="txt">
						CorDx partners with organizations around the world to develop, manufacture, and distribute diagnostics that empower users to monitor and improve their health.
					</div>
					<div class="txt">
						Through these partnerships, we can best serve those who need it with collaboration, insight, and effectiveness. Do you have a breakthrough you believe will benefit from collaboration with CorDx?
					</div>
					<div class="btn_box_more btn_box" @click="goContact">
						Contact Us<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Integrated Supply Chain for Diagnostic Customers - CorDx';
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goContractManufacturing() {
			this.$router.push({ path: '/contract-manufacturing', });
		},
		goContact() {
			this.$router.push({ path: '/contact', });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块7*/
	.block_7{
		width: 1140px;
		display: flex;
		margin: 0 auto;
		.right{
			flex: 1;
			padding-left: 40px;
			.title{
				padding: 35px 0;
				font-size: 45px;
			}
			.text{
				padding-bottom: 70px;
				font-size: 20px;
				color: #706B69;
			}
		}
		.left{
			flex: 1;
			padding-right: 40px;
			img{ width: 100%; }
		}
		.txt{
			padding: 2px 0;
			font-size: 18px;
		}
		.tit{
			padding: 50px 0 20px 0;
			font-size: 24px;
			color: #0B318F;
		}
	}
	/*块6*/
	.block_6{
		width: 1140px;
		display: flex;
		margin: 0 auto;
		padding: 140px 0 90px 0;
		.left{
			width: 300px;
			font-size: 45px;
		}
		.right{
			flex: 1;
			padding-left: 80px;
			.right_el{
				display: flex;
				align-items: center;
				margin-bottom: 50px;
				.right_left{
					width: 100px;
					img{ width: 100%; }
				}
				.right_right{
					flex: 1;
					padding-left: 40px;
					.txt{
						padding-top: 15px;
						font-size: 18px;
						color: #000000;
					}
					.tit{
						font-weight: bold;
						font-size: 24px;
						color: #000000;
					}
				}
			}
		}
	}
	/*块5*/
	.block_5{
		width: 100%;
		position: relative;
		.msg_box{
			position: absolute;
			top: 0;
			left: 50%;
			width: 1140px;
			z-index: 1;
			transform: translate(-50%, 0);
			color: #ffffff;
			padding-top: 60px;
			.btn_box{
				margin-top: 30px;
			}
			.txt{
				padding-top: 20px;
				font-size: 18px;
			}
			.tit{
				font-size: 45px;
			}
		}
		.bg{
			width: 100%;
			min-width: 1650px;
		}
	}
	/*块4*/
	.block_4{
		width: 1140px;
		margin: 0 auto;
		padding: 100px 0 150px 0;
		display: flex;
		.left, .right{
			flex: 1;
			margin: 0 20px;
			.block_4_el{
				margin-top: 50px;
				padding: 40px;
				.img_box{
					img{ width: 100%; }
				}
				.btn_box{
					margin: 20px 0;
				}
				.list{
					padding-top: 20px;
					li{
						padding: 4px 0;
					}
				}
				.txt{
					padding-top: 20px;
					font-size: 18px;
					color: #000000;
				}
				.tit{
					font-size: 45px;
					color: #000000;
				}
			}
		}
	}
	/*块3*/
	.block_3{
		width: 1140px;
		margin: 0 auto;
		display: flex;
		.left{
			flex: 1;
			padding: 40px 30px;
			background-color: #0066D4;
			color: #ffffff;
			.left_main{
				display: flex;
				height: 160px;
				width: 100%;
				margin-top: 15px;
				align-items: center;
				text-align: center;
				.left_main_el{
					flex: 1;
					height: 100%;
					margin: 0 8px;
					padding-top: 28px;
					background-color: #ffffff;
					.tit{
						font-size: 45px;
						color: #0B318F;
						font-weight: bold;
					}
					.txt{
						font-size: 18px;
						color: #000000;
						color: #0B318F;
					}
				}
			}
			.tit{
				font-size: 45px;
			}
		}
		.right{
			width: 210px;
			img{ width: 100%; }
		}
	}
	/*块2*/
	.block_2{
		width: 1140px;
		margin: 0 auto;
		padding: 70px 50px 100px 50px;
		color: #000000;
		.txt{
			padding-top: 30px;
			font-size: 18px;
		}
	}
	/*banner*/
	.banner_box{
		img{
			width: 100%;
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		margin: 0 auto;
		padding: 50px 50px 0 50px;
		color: #000000;
		text-align: center;
		.tit{
			font-size: 65px;
			line-height: 1.2;
		}
		.txt{
			padding-top: 10px;
			font-size: 30px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
